import { Container, Row, Col, Card } from 'react-bootstrap';
import './Common.scss';

export default function ExternalLink() {
  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h1 className="display-4 mb-4 text-success">外部リンク</h1>
              <h2 className="h3 text-muted mb-4">
                オーナーがこれまでの人生で生き方を学ばせてもらった団体のリンク集です。
              </h2>
              <h2 className="h3 text-muted mb-4">
                それぞれの団体の活動内容や理念に興味がある方は、ぜひご覧ください。
              </h2>
              <hr />
              <h2 className="text-success">GLA</h2>
              <p className="lead">
                主宰の高橋佳子先生は誰の中にも菩薩の心、仏性があると説き、神理を実践した先には誰もが予測していない未来があるということを多くの会員さんの人生を通して証明されています。目の前の現実がうまく行かない、人間関係で常に悩んでいる、裏切ることのない友達と出会いたい、そんな方にはおすすめです。
              </p>
              <p className="lead">
                ニートだったかつてのオーナーは、社会から必要とされていない絶望から死を考えていましたが、2015年青年塾で佳子先生と対話いただき、こんな自分でも生きていていいんだと自分を肯定できるようになり、2021年7月の青年鍛錬で一緒に学んできた特に仲のいい友人のTさんが神理実践報告で先生に呼ばれて登壇したことにより、こんな絶望しかない人生であっても神理と向き合うことでいつか報われる時が来るのだろうかと考え、自分の生き方を改めて善に生きるようになりました。今でもそこで出会った仲間たちと日常で挑戦を繰り返し、どのように自分が成長していけたのかを分かち合うことが今の原動力になっています。
              </p>
              <p className="lead">
                <a
                  href="https://www.gla.or.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GLA公式サイト
                </a>
              </p>
              <hr />
              <h2 className="text-success">モダンミステリースクール(MMS)</h2>
              <p className="lead">
                モダンミステリースクールは、古代の神秘的な知識と技術を現代に伝える団体です。MMSでは、ヒーリングやスピリチュアルな成長を促進するためのプログラムを提供しています。オーナーはここでヒーリングの技術を学び、MMS公認ヒーラーとして活動しています。特におすすめなのは形而上学講義で、なぜ私たちは支配から抜け出せないのか、なぜ戦争は無くならないのかなど、現代社会の問題を形而上学の視点から考察し、現実を変えるためのメソッドを教えてもらえます。
              </p>
              <p className="lead">
                GLAで仲良くなった友達KさんからMMSのことを聞き、アデプトプログラムを受講したときには胡散臭いという疑いの目で見て、胡散臭いけどKさんの勧めていたエンソフィックレイキヒーリングのプログラムを知るためとおとなしく受けていましたが、形而上学がGLAの神理のはるか先まで教えてくれること、伝承されてきた数々の魔術が実際に自分でも使ってみて本物だと実感できることがわかり、オーナーはそのまま学びを進めました。加えて、GLAで魂の存在を信じるようになってから自分でスピリチュアルリーダーの方と会う機会を増やし、本当の自分がスターシードであることを知っていたから銀河連盟のキーワードを聞いたあたりで本物だと確信しました。学びの中で特に有益だと感じたことは、ストレスコントロールの講義で、合わない人間と関わらなければいい、辛い記憶は考えなければいい、といった現代社会の同調圧力に真正面からNOを叩きつける価値観に共感できました。
              </p>
              <p className="lead">
                <a
                  href="https://mmsjapan.jp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  MMS公式サイト
                </a>
              </p>
              <hr />
              <h2 className="text-success">ダイナビジョン</h2>
              <p className="lead">
                ダイナビジョンは、個人の成長と自己実現をサポートするためのプログラムを提供しています。オーナーはMMSのことを知る前は、こちらに所属しているヒーラーやサイキックの方々、あるいはこの会社さんと提携している諸外国のサイキックの方々から自らの魂の由来やこの世界で自分は何がしたかったのかといった魂の目的や由来を教えてもらう際にお世話になっていました。例えば、カナダ在住のサイキックであるケイト・キングさんからオーナーがスターシードであることや、3転生前にサイキックを使用していたことなどの情報をいただいたり、目黒でのセッションなどでかつて修行僧であったことやアシュタールとの関わり、レムリアで神官をしていた魂だったことなどをダイナビジョンに所属するヒーラーの方々から教わったりもしました。
              </p>
              <p className="lead">
                最終的には現実を変えるのは自らの行動ですが、自分を知ることができなければ、その原動力は生まれません。自分の人生のテーマや魂の目的を知ることで、より深い自己理解と成長が可能になります。ダイナビジョンは、そのような自己発見の旅をサポートするための素晴らしいリソースです。
              </p>
              <p className="lead">
                <a
                  href="https://www.dynavision.co.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ダイナビジョン公式サイト
                </a>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
